<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-theme-option-font-size [fontSize]="themeOptions.options().tooltips.bodyFontSize" (sendFontSize)="receiveValue($event)"></app-theme-option-font-size>
  </div>
</app-theme-option>